import { UserFunctionsType, IconType, OptionMenuType } from '../enumerators/enumerators.enum';

export class MenuOption {

    screenIdentifier!: number;
    moduleType: OptionMenuType = OptionMenuType.Screen;
    path: string = '';
    title: string = '';
    icon: string = 'fa-circle-o';
    homeScreen: boolean = false;
    isOpen: boolean = false;
    isActive: boolean = false;
    subMenu: Array<MenuOption> = [];
    order: number = 0;
    homeOrder: number = 0;
    description?: string = '';
    function: UserFunctionsType = UserFunctionsType.ChangePassword;
    security?: boolean;
    twoParams?: boolean;

    constructor(init?: Partial<MenuOption>) {
        Object.assign(this, init);
    }

}
